<template>
  <div class="w-full">
    <label :for="fieldId" class="block font-medium text-slate-800 mb-1">
      {{ label }}
      <span v-if="unit" class="text-slate-500 font-normal">({{ unit }})</span>
    </label>
    <p v-if="hint" class="text-xs text-slate-500 mb-2 leading-relaxed">{{ hint }}</p>
    <input
      :id="fieldId"
      class="form-input bg-white w-full"
      type="number"
      inputmode="decimal"
      :min="min"
      :step="step"
      :placeholder="placeholder"
      :value="modelValue"
      @input="onInput"
    />
  </div>
</template>

<script>
let uid = 0;

export default {
  name: "NumberField",
  props: {
    modelValue: { type: [Number, String], default: 0 },
    label: { type: String, required: true },
    unit: { type: String, default: "" },
    hint: { type: String, default: "" },
    placeholder: { type: String, default: "0" },
    min: { type: Number, default: 0 },
    step: { type: Number, default: 1 },
  },
  emits: ["update:modelValue"],
  data() {
    uid += 1;
    return { fieldId: `number-field-${uid}` };
  },
  methods: {
    onInput(event) {
      const raw = event.target.value;
      const value = raw === "" ? 0 : Number(raw);
      this.$emit("update:modelValue", Number.isFinite(value) ? Math.max(this.min, value) : 0);
    },
  },
};
</script>
